import type { SessionDto } from "~/ui-rtk/api/types/user.types"

/**
 * The session's currentCompany is the tenant for every API call, so a `_c_id`
 * link must switch the session BEFORE any page fires requests — otherwise
 * early calls (e.g. POST /assets/resolve) run against the previous company
 * and can create assets under the wrong tenant.
 *
 * Returns the company to switch to, or undefined when no switch is needed or
 * the user has no access. The membership gate matters: /auth/switch-company
 * silently falls back to the user's first company when the target isn't in
 * their list, which would bounce a no-access user off their current company.
 * Super admins are covered — their session lists every company.
 */
export function getCompanySwitchTarget(
  session: SessionDto | undefined,
  companyIdFromUrl: string | undefined,
): string | undefined {
  if (!session || !companyIdFromUrl) {
    return undefined
  }
  if (companyIdFromUrl === session.currentCompany.id) {
    return undefined
  }
  return session.user.companies.some(c => c.companyId === companyIdFromUrl)
    ? companyIdFromUrl
    : undefined
}
